export const GET_ACCOUNT_TYPES = 'GET_ACCOUNT_TYPES'
export const GET_ACCOUNT_TYPE = 'GET_ACCOUNT_TYPE'
export const DELETE_ACCOUNT_TYPE = 'DELETE_ACCOUNT_TYPE'
export const ADD_ACCOUNT_TYPE = 'ADD_ACCOUNT_TYPE'
export const DELETE_MANY_ACCOUNT_TYPE = 'DELETE_MANY_ACCOUNT_TYPE'
export const UPDATE_ACCOUNT_TYPE = 'UPDATE_ACCOUNT_TYPE'
